import { generateRootObjectSchema, generateStringSchema, generateUrlSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("NV Play Video Player", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  layoutType: generateStringSchema("Layout Type", "Specify \"embedded\" to use the video player as a static/single video player for all of the other video highlights in the page.", {
    choices: ['embedded'],
    choiceTitles: ['Embedded'],
  }),
  videoUrl: generateUrlSchema("Video URL", "A fully-qualified URL for the video to be shown in the widget."),
  thumbUrl: generateUrlSchema("Thumbnail URL", "A fully-qualified URL for the thumbnail/poster image to be displayed before the video is played by the user."),
}));
